import React from "react";
import { Link } from "react-router-dom";
import CcgRoutePremiumPage from "../components/CcgRoutePremiumPage";
import PostcodeQuotenew from "./PostcodeQuotenew";
import "./CcgRoutePremium.css";

const cardGrid = (className, cards) => (
  <div className={className}>
    {cards.map((card) => (
      <article className={card.className || ""} key={card.title}>
        <h3>{card.title}</h3>
        {card.body ? <p>{card.body}</p> : null}
        {card.items ? <ul>{card.items.map((item) => <li key={item}>{item}</li>)}</ul> : null}
        {card.link ? <Link to={card.link.to} className={card.link.className || "route-link-inline"}>{card.link.label}</Link> : null}
        {card.links ? <div className="route-link-btn-row">{card.links.map((link) => <Link to={link.to} className={link.className || "route-link-btn"} key={link.to}>{link.label}</Link>)}</div> : null}
      </article>
    ))}
  </div>
);

const burnhamToHeathrowRoute = {
  id: "burnham-to-heathrow",
  path: "/burnham-to-heathrow",
  liveStripVariant: "slough",
  seo: {
    title: "Burnham to Heathrow Taxi - Fixed-Price Airport Transfers | CheapCabGrab",
    description:
      "Book a fixed-price taxi from Burnham to Heathrow. Burnham station, Burnham Beeches and Burnham Beeches Hotel & Spa pickups with licensed drivers, flight tracking and no surge pricing.",
    keywords:
      "Burnham to Heathrow taxi, Burnham station to Heathrow taxi, Burnham Beeches to Heathrow taxi, Burnham airport transfer, Burnham Heathrow transfer, CheapCabGrab",
    canonical: "https://www.cheapcabgrab.com/burnham-to-heathrow",
    ogTitle: "Burnham to Heathrow Taxi - Fixed Airport Transfers",
    ogDescription:
      "Reliable Burnham to Heathrow taxis with fixed fares, licensed drivers and live flight tracking. Book online in seconds with CheapCabGrab.",
    serviceName: "CheapCabGrab - Burnham to Heathrow Taxi",
    areaServed: ["Heathrow Airport", "Burnham", "Burnham Station", "Burnham Beeches", "Burnham Beeches Hotel & Spa"],
    offerCatalogName: "Burnham to Heathrow Taxi Routes",
    offerName: "Burnham to Heathrow Airport fixed-price taxi",
    offerDescription: "Fixed-price taxi transfers from Burnham to Heathrow Airport terminals with licensed drivers and flight tracking.",
    reservationName: "Taxi booking from Burnham to Heathrow",
  },
  hero: {
    eyebrow: "Burnham to Heathrow taxi route",
    h1: "Burnham to Heathrow Taxi - Fixed-Price Airport Transfers",
    subtitle: "Burnham station, Burnham Beeches and hotel pickups for Heathrow terminals 2, 3, 4 and 5.",
    body:
      "Book reliable taxis from Burnham to Heathrow with licensed drivers, flight tracking and secure online booking. Fixed upfront fares with no surge pricing.",
  },
  quote: {
    label: "Get instant quotes",
    note: "Free - Fast - No obligation",
    presetPickup: "Burnham, SL1",
    presetDropoff: "Heathrow Airport",
  },
  flags: [
    "Fixed fares agreed upfront - no meters",
    "Live flight tracking for Heathrow arrivals",
    "Burnham station and hotel pickups",
    "Saloon, MPV, minibus and coach options",
  ],
  reviewPageKey: "/burnham-to-heathrow",
  reviewAriaLabel: "Burnham to Heathrow customer reviews",
  lhrStatusTitle: "Live Heathrow checks for Burnham to Heathrow taxis",
  floatingCta: "Book Burnham to Heathrow Taxi",
  mobileCta: "Book Burnham to Heathrow Taxi",
  supportNudge: "Need Burnham to Heathrow help?",
  sections: [
    {
      id: "route-overview",
      title: "Burnham to Heathrow at a glance",
      body: "A short airport route for Burnham homes, station connections, Burnham Beeches visitors and hotel guests.",
      render: () => cardGrid("route-overview-grid", [
        {
          title: "Journey basics",
          items: [
            "Distance: Approx. 10-14 miles depending on pickup point and terminal",
            "Typical time: 20-35 minutes",
            "Typical saloon fare: from GBP38-GBP58",
            "Areas covered: Burnham, Lent Rise, Burnham Beeches, Cippenham edge and nearby SL postcodes",
          ],
        },
        {
          title: "Great for",
          items: [
            "Heathrow departures from Burnham station or homes",
            "Burnham Beeches Hotel & Spa airport transfers",
            "Families with luggage or child seats",
            "Business travellers needing fixed fares and receipts",
          ],
        },
        {
          title: "Local planning links",
          links: [
            { to: "/burnham-taxi", label: "Burnham taxi" },
            { to: "/slough-to-heathrow", label: "Slough to Heathrow", className: "route-link-btn route-link-btn-secondary" },
          ],
        },
      ]),
    },
    {
      id: "route-tools",
      title: "Useful tools for your Burnham to Heathrow journey",
      body: "Check terminals, live Heathrow status and airport transfer options before you travel.",
      render: () => cardGrid("route-links-grid", [
        { title: "Heathrow Terminal Finder", body: "Check the correct Heathrow terminal before booking or travelling.", link: { to: "/terminalFinder", label: "Open Terminal Finder", className: "route-link-btn" } },
        { title: "Heathrow hotel guide", body: "Useful if your Burnham pickup connects to a Heathrow hotel or onward terminal transfer.", link: { to: "/heathrow-hotels", label: "See Heathrow hotels", className: "route-link-btn" } },
        { title: "Group travel", body: "Need more luggage space from Burnham? Use minibus or coach options for groups.", links: [{ to: "/minibus", label: "Minibus" }, { to: "/coach", label: "Coach", className: "route-link-btn route-link-btn-secondary" }] },
      ]),
    },
    {
      id: "route-faq",
      title: "Burnham to Heathrow taxi - FAQs",
      body: "Common questions for Burnham airport transfers.",
      render: () => (
        <div className="route-faq-grid">
          {[
            ["How long does Burnham to Heathrow take?", "Most Burnham to Heathrow taxi journeys take around 20-35 minutes, depending on traffic, pickup point and terminal."],
            ["Can you pick up from Burnham station?", "Yes. Burnham station is a regular pickup point for Heathrow transfers and local onward journeys."],
            ["Can you collect from Burnham Beeches Hotel & Spa?", "Yes. We handle Heathrow transfers from Burnham Beeches Hotel & Spa for guests, events and spa stays."],
            ["Do you track Heathrow flights?", "Yes. For Heathrow pickups we monitor your flight and adjust dispatch timing where possible."],
          ].map(([title, body]) => <article className="route-faq-card" key={title}><h3>{title}</h3><p>{body}</p></article>)}
        </div>
      ),
    },
  ],
};

const BurnhamToHeathrow = () => (
  <CcgRoutePremiumPage route={burnhamToHeathrowRoute} QuoteComponent={PostcodeQuotenew} />
);

export default BurnhamToHeathrow;
